module.exports = __webpack_public_path__ + "img/zutto-the-wave.5f58775.jpg";